export default "__VITE_ASSET__d61f3c58__"